import { render } from "./SpecimenDescription.vue?vue&type=template&id=7e4d927a&scoped=true"
import script from "./SpecimenDescription.vue?vue&type=script&lang=js"
export * from "./SpecimenDescription.vue?vue&type=script&lang=js"

import "./SpecimenDescription.vue?vue&type=style&index=0&id=7e4d927a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e4d927a"]])

export default __exports__